import { FileRecord } from '@approvalmax/ui/src/components';
import { components, DocumentType } from 'shared/data/walletsKyc/v1';

export const buildAdditionalDocumentsInitialValues = (
    additionalDocuments: components['schemas']['FormAdditionalDocumentsAnswer'] | undefined
) =>
    (additionalDocuments?.documents ?? []).reduce<{
        proofOfFunds: FileRecord[];
        other: FileRecord[];
    }>(
        (acc, { id, type, documentImages }) => {
            if (type === DocumentType.proof_of_source_of_funds) {
                acc.proofOfFunds.push({
                    id,
                    name: documentImages[0].name,
                });
            } else {
                acc.other.push({
                    id,
                    name: documentImages[0].name,
                });
            }

            return acc;
        },
        {
            proofOfFunds: [],
            other: [],
        }
    );
